import { DateTime } from 'luxon';

export const formatDate = (timestamp: number, format: string = 'HH:mm, dd.MM.yyyy') =>
  DateTime.fromSeconds(timestamp).toFormat(format);

export const getEndOfDay = (dateTime: DateTime = DateTime.local()) =>
  new Date(dateTime.endOf('day').toMillis());

export const getStartOfDay = (dateTime: DateTime = DateTime.local()) =>
  new Date(dateTime.startOf('day').toMillis());

export const getStartOfWeek = (dateTime: DateTime = DateTime.local()) => {
  return new Date(dateTime.startOf('week').toMillis());
};

export const getPreviousDayStart = (dateTime: DateTime = DateTime.local()) => {
  return new Date(dateTime.minus({ day: 1 }).startOf('day').toMillis());
};

export const getNextDayStart = (dateTime: DateTime = DateTime.local()) => {
  const currentMoment = DateTime.local();
  return new Date(
    (dateTime >= currentMoment ? dateTime : currentMoment)
      .plus({ day: 1 })
      .startOf('day')
      .toMillis(),
  );
};

export const getCurrentDayStart = (): Date => {
  return new Date(DateTime.local().startOf('day').toMillis());
};

export const toTimestamp = (date: number | Date): number =>
  Math.floor(new Date(date).getTime() / 1000);

export const secondsFromMidnightToHHMM = (secondsFromMidnight: number | null): string => {
  if (secondsFromMidnight === null) {
    return '';
  }
  const h = `0${Math.floor(secondsFromMidnight / 3600)}`.slice(-2);
  const m = `0${Math.floor(Math.floor((secondsFromMidnight % 3600) / 60))}`.slice(-2);
  return `${h}:${m}`;
};

export const HHMMSStoSeconds = (
  timeString: string,
  separator = ':',
  forceSeconds?: number,
): number | null => {
  if (timeString.length < 5) {
    return null;
  }

  const timeParts = timeString.split(separator);
  if (timeParts.length === 1) {
    return null;
  }
  const hoursNumber = parseInt(timeParts[0], 10);
  if (Number.isNaN(hoursNumber) || hoursNumber > 23) {
    return null;
  }

  const minutesNumber = parseInt(timeParts[1], 10);
  if (Number.isNaN(minutesNumber) || minutesNumber > 59) {
    return null;
  }

  let secondsNumber = timeParts[2] ? parseInt(timeParts[2], 10) : 0;
  if (Number.isNaN(secondsNumber) || secondsNumber > 59) {
    return null;
  }

  if (forceSeconds) {
    secondsNumber = forceSeconds;
  }

  return hoursNumber * 3600 + minutesNumber * 60 + secondsNumber;
};
